import Vue from 'vue';
import moment from 'moment';
import 'moment/locale/es';

Vue.filter('formatDate', (value: string) => {
    if (value) {
        return moment(String(value)).format('LL')
    }
    return '';
});
